import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';
import { mergeStyles } from '@cian/utils';

import { IOfferCardBlockProps } from '../../types';

import * as styles from './styles.css';

export const OfferCardBlock: React.FC<IOfferCardBlockProps> = props => {
  const { className, previewImage, title, expoTime } = props;

  return (
    <div {...mergeStyles(styles['flex'], className)}>
      <div className={styles['img-link-wrapper']}>{previewImage}</div>
      <div>
        <div className={styles['title']}>{title}</div>
        <div className={styles['caption']}>
          <InlineText2 color="black_60">{expoTime}</InlineText2>
        </div>
      </div>
    </div>
  );
};

OfferCardBlock.displayName = 'OfferCardBlock';
